import { debounce } from './utils/utils';
const descHeader = document.querySelector('.desc-header');
let winWidth = window.innerWidth;


let updateWidth = debounce(function () {
    winWidth = window.innerWidth;
    if (descHeader) descHeader.style.top = `${getHeaderHeight() - 1}px`;
    let navBar = document.querySelector(".desc-navigation-wrapper");
    if (!navBar) return;

    navBar.style.top = `${getHeaderHeight() + getDescHeaderHeight() - 1}px`;
    let scrollingTable = document.querySelector('.compare-table tr:nth-child(1)');
    if (scrollingTable) scrollingTable.style.top = `${getHeaderHeight() + getDescHeaderHeight() + navBar.clientHeight - 1}px`;
}, 100);
window.addEventListener('resize', () => {
    updateWidth();
});
updateWidth();

export function getDescHeaderHeight() {
    if (!descHeader || winWidth < 1280 || document.querySelector('.cart-disabled')) return 0;
    return (descHeader ? descHeader.clientHeight : 0);
}


export function scrollToElement(target, customOffsetTop, customOffsetBottom, scrollFinishCallback) {
    if (!target) return;

    initScroll()
        .then(scrollFinishCallback);

    function initScroll() {

        return new Promise((resolve) => {
            target.style.scrollMargin = `
            ${((customOffsetTop || customOffsetTop === 0) ? customOffsetTop : 16) + getHeaderHeight() + getDescHeaderHeight() }px
            ${((customOffsetBottom || customOffsetBottom === 0) ? customOffsetBottom : 16)}px`;

            target.scrollIntoView({
                behavior: 'smooth',
            });


            const onScroll = () => {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(() => {
                    window.removeEventListener("scroll", onScroll);
                    resolve();
                }, 50);
            };

            let scrollTimeout;
            window.addEventListener("scroll", onScroll);
        });
    }
}

export function getHeaderHeight() {
    const header = document.querySelector(".shop-header");
    if (!header) return 0;

    let headerHeight = header.clientHeight;
    if (headerHeight === 0) return 0;

    let proofBanners = document.querySelector('.proof-banners-wrapper');
    if (proofBanners && window.innerWidth > 1280) {
        headerHeight = headerHeight + proofBanners.clientHeight;
    }

    return (headerHeight + getScrollOffset(header));
}

function getScrollOffset(header) {
    let offset = 0;

    const cs = getComputedStyle(document.documentElement);
    
    let headerScrollTransform = parseFloat(cs.getPropertyValue('--headerScrollTransform'));
    if (headerScrollTransform) offset += headerScrollTransform;

    let headerHeightChange = parseFloat(cs.getPropertyValue('--headerHeightChange'));
    if (!header.classList.contains("stuck") && headerHeightChange) offset -= headerHeightChange;

    return offset;
}

export { updateWidth };